import { graphql } from "api/cms-website/generated";

export const SliderItemFragment = graphql(/* GraphQL */ `
    fragment SliderItemFragment on ComponentElementsSliderItem {
        title
        text
        rating
        customerName
        date
    }
`);
